import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgStopCircle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M21 11.999A9 9 0 0 0 12 3a9 9 0 1 0 9 8.999"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M13.276 9.273h-2.554c-.89 0-1.449.631-1.449 1.522v2.407c0 .892.556 1.522 1.45 1.522h2.553c.893 0 1.45-.63 1.45-1.522v-2.407c0-.891-.557-1.522-1.45-1.522"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgStopCircle);
export default ForwardRef;
